import { Injectable } from '@angular/core';
import { HttpClient } from 'src/core/common/domain/http/http-client';
import { ApiService } from 'src/core/api/domain/api.service';
import { ExceptionManagerService } from 'src/core/common/domain/exceptions/exception-manager.service';
import { AccessToken } from 'src/core/authentication/domain/access-token';
import { ApiAccessResponse } from 'src/core/authentication/infrastructure/api-access-response';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { InvalidCredentialsException } from 'src/core/authentication/domain/exceptions/invalid-credentials-exception';
import { SessionService } from 'src/core/session/domain/session.service';
import { UnauthorizedException } from 'src/core/authentication/domain/exceptions/unauthorized-exception';

@Injectable({
  providedIn: 'any',
})
export class ApiAccessService {
  constructor(
    private readonly client: HttpClient,
    private readonly apiService: ApiService,
    private readonly session: SessionService,
    private readonly exceptionManager: ExceptionManagerService
  ) {}

  async getAccess(): Promise<void> {
    const headers = {
      Authorization: `Basic ${this.apiService.getBasicAuthorizationToken()}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    const grantType = 'password'; // hardcoded
    const password = this.apiService.getPasswordToken();
    const username = this.apiService.getUsernameToken();

    try {
      const response = await this.client.post<ApiAccessResponse>(
        `${this.apiService.baseAccessUrl()}?grant_type=${grantType}&username=${username}&password=${password}`,
        null,
        headers,
        false,
        false
      );
      const accessToken = new AccessToken(response.access_token);
      await this.session.saveAccessToken(accessToken);
    } catch (exception) {
      // specific exceptions management
      if (exception instanceof HttpErrorResponse) {
        switch (exception.status) {
          case HttpStatusCode.Unauthorized:
            throw InvalidCredentialsException.fromError(exception);
        }
      }

      // general exceptions management
      throw this.exceptionManager.manage(exception);
    }
  }

  async renewApiAccessIfNeeded() {
    const accessToken = this.session.getAccessToken();
    if (accessToken === null) {
      throw new UnauthorizedException();
    }

    if (!accessToken.isExpired()) {
      return;
    }

    await this.getAccess();
    console.warn(' - API access token renewed after expiration');
  }
}
